<template>
    <div class="scrollable-view">
        <div ref="scrollableContent" class="scrollable-content scrollable" :class="props.contentClass">
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from "vue";

    // define props
    const props = defineProps<{
        contentClass?: string;
    }>();

    const scrollableContent = ref<HTMLElement | null>(null);

    function scrollToTop() {
        scrollableContent.value?.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    defineExpose({
        scrollToTop,
    });
</script>

<style lang="scss">
    .scrollable-view {
        position: relative;

        .scrollable-content {
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            position: absolute;
            -webkit-overflow-scrolling: touch;
            overflow: hidden;
        }

        .scrollable-content::-webkit-scrollbar-track {
            background-color: rgba(222, 222, 222, 0.75);
        }

        .scrollable-content::-webkit-scrollbar {
            background-color: #f5f5f5;
            width: 8px;
        }

        .scrollable-content::-webkit-scrollbar-thumb {
            background-color: #bbb;
            transition: background-color 0.5s cubic-bezier(0.16, 1, 0.3, 1);

            &:hover {
                background-color: #999;
            }
        }

        &:not(.horizontal):not([horizontal]):not(.vertical):not([vertical]) {
            > .scrollable-content {
                overflow-y: auto;
            }
        }

        &.horizontal,
        &[horizontal] {
            > .scrollable-content {
                overflow-x: auto;
            }
        }

        &.vertical,
        &[vertical] {
            > .scrollable-content {
                overflow-y: auto;
            }
        }
    }

    .styled-scrollbar::-webkit-scrollbar-track {
        background-color: rgba(222, 222, 222, 0.75);
    }

    .styled-scrollbar::-webkit-scrollbar {
        background-color: #f5f5f5;
        width: 8px;
        height: 8px;
    }

    .styled-scrollbar::-webkit-scrollbar-thumb {
        background-color: #bbb;
        transition: background-color 0.5s cubic-bezier(0.16, 1, 0.3, 1);

        &:hover {
            background-color: #999;
        }
    }
</style>
